// ** Dropdowns Imports
import IntlDropdown from './IntlDropdown';
// import CartDropdown from './CartDropdown';
import UserDropdown from './UserDropdown';
import NavbarSearch from './NavbarSearch';
import NotificationDropdown from './NotificationDropdown';

// ** Reactstrap Imports
import { NavItem, NavLink } from 'reactstrap';

const NavbarUser = (props) => {
    return (
        <ul className="nav navbar-nav align-items-center ms-auto">
            {/* <IntlDropdown /> */}
            {/* <NavbarSearch /> */}
            {/* <CartDropdown /> */}
            {/* <NotificationDropdown /> */}
            <UserDropdown />
        </ul>
    );
};
export default NavbarUser;
